module.exports = __webpack_public_path__ + "static/mir-aminy-social-c7b8b6212c8d2b57ae16c28b64d4a858.jpg";